import React from 'react';
import { useLocation, useNavigate } from "react-router-dom";

// Tab styling matches the dark hub top bar this now sits in
export default () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const itemStyle = {
    color: 'rgba(255, 255, 255, 0.7)',
    padding: '6px 12px',
    cursor: 'pointer',
    borderRadius: '10px',
    fontSize: '14px',
    whiteSpace: 'nowrap'
  }

  const selectedStyle = {
    background: 'rgba(255, 255, 255, 0.15)',
    color: '#ffffff'
  }

  const onItemClicked = (name) => {
    if (!pathname?.includes(name)) {
      navigate(`${name}`);
    }
  }

  return (
    <div style={{
      display: 'flex',
      columnGap: '4px',
    }}>
      <div 
        style={{
          ...itemStyle,
          ...(pathname?.includes('builder') ? selectedStyle : {})
        }}
        onClick={() => onItemClicked('builder')}
      >
        {'Assessment Builder'}
      </div>
      <div 
        style={{
          ...itemStyle,
          ...(pathname?.includes('reports') ? selectedStyle : {})
        }}
        onClick={() => onItemClicked('reports')}
      >
        {'Assessment Reports'}
      </div>
    </div>
  )
}
